import { useNewsArticleData } from '@dreamstack/accentro-contentful/src/contentful/news/useNewsArticleData'
import {
  getStaticNewsArticlePathsOptions,
  getStaticNewsArticlePropsOptions,
} from '@dreamstack/accentro-contentful/src/contentful/news/getStaticNewsArticle'
import { NewsArticle } from '@dreamstack/feature-components/src/news/NewsArticle'
import { getStaticPathsPlus } from '../../../lib/getStaticPathsPlus'
import { getStaticPropsPlus } from '../../../lib/getStaticPropsPlus'

export default function NewsArticlePage() {
  const props = useNewsArticleData()
  if (!props) return null
  return <NewsArticle {...props} />
}

export const getStaticProps = getStaticPropsPlus(
  getStaticNewsArticlePropsOptions
)

export const getStaticPaths = getStaticPathsPlus(
  getStaticNewsArticlePathsOptions
)
